import { render } from "./mobile-homepage.vue?vue&type=template&id=30bcd844&scoped=true"
import script from "./mobile-homepage.vue?vue&type=script&lang=js"
export * from "./mobile-homepage.vue?vue&type=script&lang=js"

import "./mobile-homepage.vue?vue&type=style&index=0&id=30bcd844&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30bcd844"]])

export default __exports__